import React__default from 'react';
import './loading.css.js';

function AuroraLoader({ size = 72, color = "#6750A4", // MD3 primary-ish
trackColor = "rgba(103,80,164,0.15)", strokeWidth = 6, speed = 1.6, text = "Loading…", glow = true, }) {
    // SVG circle math
    const radius = 50 - strokeWidth; // viewBox 0 0 100 100
    const dashArray = Math.PI * 2 * radius;
    return (React__default.createElement("div", { className: "aurora-wrap", style: { width: size, height: size } },
        React__default.createElement("svg", { className: `aurora ${glow ? "aurora--glow" : ""}`, viewBox: "0 0 100 100", style: {
                "--stroke": color,
                "--track": trackColor,
                "--sw": `${strokeWidth}px`,
                "--dash": dashArray,
                "--speed": `${speed}s`,
            }, role: "status", "aria-label": text || "Loading" },
            React__default.createElement("circle", { className: "aurora__track", cx: "50", cy: "50", r: radius, fill: "none", strokeWidth: strokeWidth }),
            React__default.createElement("circle", { className: "aurora__arc", cx: "50", cy: "50", r: radius, fill: "none", strokeWidth: strokeWidth, strokeLinecap: "round" }),
            React__default.createElement("circle", { className: "aurora__pulse", cx: "50", cy: "50", r: "22" })),
        text !== "" && React__default.createElement("div", { className: "aurora__label" }, text)));
}

export { AuroraLoader };
//# sourceMappingURL=Loading.js.map
